import "./App.css";

import { createBrowserRouter, RouterProvider } from "react-router";
import HumanizeTextsMain from "./components/humanize_texts/HumanizeTextsMain";
import AIDetectorMain from "./components/ai_detector/AIDetectorMain";
import ApiMain from "./components/api/ApiMain";
import PrivacyPolicy from "./components/misc/PrivacyPolicy";
import TermsOfService from "./components/misc/TermsOfService";
import Pricing from "./components/pricing/PricingMain";
import LoginMain from "./components/login/LoginMain";
import SignUpMain from "./components/signup/SignUpMain";
import ForgotPasswordMain from "./components/forgot_password/ForgotPasswordMain";
import HistoryMain from "./components/history/HistoryMain";
import ParaphraseMain from "./components/paraphrase/ParaphraseMain";
import { createContext, useState, useEffect } from "react";
import {
  AUTHENTICATION_URL,
  MAX_AI_TEXT_LENGTH_DEFAULT,
} from "./components/Config";
import LoadingBar from "react-top-loading-bar";
import VerifyEmailMain from "./components/verify_email/VerifyEmailMain";
import PageNotFound from "./components/PageNotFound";
import AccountDetailsMain from "./components/account_details/AccountDetailsMain";
import ChangePasswordMain from "./components/forgot_password/ChangePasswordMain";
import { PayPalScriptProvider } from "@paypal/react-paypal-js";
import PurchaseMain from "./components/purchase/PurchaseMain";
// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import AIImageDetectorMain from "./components/ai_detector_image/AIImageDetectorMain";
import SummarizerMain from "./components/summarize/SummarizerMain";
import PlagiarismMain from "./components/plagiarism/PlagiarismMain";

//create context
export const LoggedInContext = createContext({
  is_logged_in: false,
  MAX_AI_TEXT_LENGTH: MAX_AI_TEXT_LENGTH_DEFAULT,
});

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBYidY1yT2iJT3773MtKWXZs8WjvkBR-ew",
  authDomain: "humanizetexts.firebaseapp.com",
  projectId: "humanizetexts",
  storageBucket: "humanizetexts.firebasestorage.app",
  messagingSenderId: "841538097404",
  appId: "1:841538097404:web:43bfe4ce45e54e712c4779",
  measurementId: "G-CQECW60NB4",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

//export
export { analytics };

function App() {
  //PayPal initialization
  //set app client id
  //stored in enviorenment file
  //change client id with live app client id before publishing
  const initialOptions = {
    "client-id": process.env.REACT_APP_PAYPAL_CLIENT_ID, // Replace with your actual client ID
    currency: "USD",
    intent: "capture",
  };

  //state
  const [isLoggedIn, setIsLoggedIn] = useState({
    is_logged_in: false,
  });

  //check if logged in
  const [checkIfLoggedin, setCheckIfLoggedin] = useState(true);
  //max text length
  const [maxAITextLength, setMaxAITextLength] = useState(700);

  const router = createBrowserRouter([
    {
      path: "/",
      element: <HumanizeTextsMain />,
    },
    {
      path: "/ai-detector",
      element: <AIDetectorMain />,
    },
    {
      path: "/ai-image-detector",
      element: <AIImageDetectorMain />,
    },
    {
      path: "/api",
      element: <ApiMain />,
    },
    {
      path: "/privacy-policy",
      element: <PrivacyPolicy />,
    },
    {
      path: "/terms-of-service",
      element: <TermsOfService />,
    },
    {
      path: "/pricing",
      element: <Pricing />,
    },
    {
      //protected routes
      path: "/login",
      element: isLoggedIn.is_logged_in ? <HumanizeTextsMain /> : <LoginMain />,
    },
    {
      //protected routes
      path: "/signup",
      element: isLoggedIn.is_logged_in ? <HumanizeTextsMain /> : <SignUpMain />,
    },
    {
      //protected routes
      path: "/forgotpassword",
      element: isLoggedIn.is_logged_in ? (
        <HumanizeTextsMain />
      ) : (
        <ForgotPasswordMain />
      ),
    },
    {
      //protected routes
      path: "/verify_email",
      element: <VerifyEmailMain />,
    },
    {
      path: "/history",
      element:
        isLoggedIn.is_logged_in === false ? (
          <HumanizeTextsMain />
        ) : (
          <HistoryMain />
        ),
    },
    {
      path: "/text-summarizer",
      element: <SummarizerMain />,
    },
    {
      path: "/plagiarism-checker",
      element: <PlagiarismMain />,
    },
    {
      path: "/paraphrase",
      element: <ParaphraseMain />,
    },
    {
      path: "/myaccount",
      element:
        isLoggedIn.is_logged_in === false ? (
          <HumanizeTextsMain />
        ) : (
          <AccountDetailsMain />
        ),
    },
    {
      //
      path: "/change_password",
      element: isLoggedIn.is_logged_in ? (
        <HumanizeTextsMain />
      ) : (
        <ChangePasswordMain />
      ),
    },
    {
      //
      path: "/purchase",
      element: isLoggedIn.is_logged_in ? <PurchaseMain /> : <LoginMain />,
    },
    {
      //404 routes
      path: "/*",
      element: <PageNotFound />,
    },
  ]);

  //run for once at startup
  useEffect(() => {
    //check
    if (checkIfLoggedin === true) {
      //call endpoint to check if logged in
      checkIfUserLoggedInEndpoint();
      //start loading
      startLoading();

      console.log("Check if logged in");
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [checkIfLoggedin]);

  //loading progress
  const [progress, setProgress] = useState(0);

  // Function to simulate progress updates
  const startLoading = () => {
    setProgress(30); // Start with some progress
    // Simulate an async operation
    setTimeout(() => {
      setProgress(70);
    }, 500);
  };

  //check if logged in endpoint
  const checkIfUserLoggedInEndpoint = async () => {
    //get the access token from local storage
    var accessToken = localStorage.getItem("access_token");
    accessToken =
      accessToken !== null && accessToken !== "undefined" ? accessToken : "";

    //fetch the status from the API
    await fetch(AUTHENTICATION_URL, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`, // if needed
      },
      body: JSON.stringify({
        request_type: "CHECK_IF_LOGGED_IN",
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        //scroll to top
        window.scrollTo(0, 0);
        //set
        setCheckIfLoggedin(false);
        //check
        if (data.success === true) {
          //set max ai text
          setMaxAITextLength(
            Math.max(
              MAX_AI_TEXT_LENGTH_DEFAULT,
              data.max_character_process_at_a_time
            )
          );

          //set
          if (data.is_logged_in === "1") {
            //set
            setIsLoggedIn({
              is_logged_in: true,
            });
          } else {
            //set
            setIsLoggedIn({
              is_logged_in: false,
            });
          }
        }

        // Simulate an async operation
        setTimeout(() => {
          //set progress
          setProgress(100);
        }, 500);

        console.log("Response Data:", data);
      })
      .catch((error) => {
        console.error("Error:", error);
        //set
        setCheckIfLoggedin(false);
        // Simulate an async operation
        setTimeout(() => {
          //set progress
          setProgress(100);
        }, 500);
      });
  };

  return (
    <PayPalScriptProvider options={initialOptions}>
      <LoggedInContext.Provider
        value={{
          isLoggedIn,
          setIsLoggedIn,
          maxAITextLength,
          setMaxAITextLength,
          setCheckIfLoggedin,
        }}
      >
        <LoadingBar
          progress={progress}
          onLoaderFinished={() => setProgress(0)} // Reset on completion
        />
        <RouterProvider router={router} />
      </LoggedInContext.Provider>
    </PayPalScriptProvider>
  );
}

export default App;
